import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 5px 5px;
  text-align: left;
  font-size: 13px;

  button {
    font-size: 13px;
    padding: 0;
    margin-left: 5px;
    margin-bottom: 2px;
  }
`;

function SelectAllButton({ isAllSelected, onSelectAll, onClearSelection, totalCount }) {
  if (isAllSelected) {
    return (
      <Wrapper>
        <span>All {totalCount} items are selected.</span>
        <button onClick={onClearSelection} className="btn btn-link waves-effect">
          Clear selection
        </button>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <span>All items on this page are selected.</span>
      <button onClick={onSelectAll} className="btn btn-link waves-effect">
        Select all {totalCount} items
      </button>
    </Wrapper>
  );
}

export default SelectAllButton;